import { useEffect, useState } from "react";
import axios from "axios";
import { Check, Loader2 } from "lucide-react";
import { NavBar } from "@/components/NavBar";
import { CheckoutPanel } from "@/components/CheckoutPanel";
import { KineticHero } from "@/components/KineticHero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing({ dark, toggleTheme }) {
  const [showcase, setShowcase] = useState(null);

  useEffect(() => {
    axios.get(`${API}/showcase`).then((r) => setShowcase(r.data)).catch(() => {});
  }, []);

  if (!showcase) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <NavBar dark={dark} toggleTheme={toggleTheme} />
      <KineticHero showcase={showcase} />
      <Marquee items={["Pay", "Unlock", "Done", "Zero data stored", "Cancel anytime", "Secured by Stripe"]} />

      <main>
        <section id="checkout" className="max-w-6xl mx-auto px-6 py-28 grid lg:grid-cols-[0.9fr_1.1fr] gap-16 items-start">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-accent mb-5">Chapter 02 — The Unlock</p>
            <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium mb-6">
              Pick a tier.<br />{showcase.app_name} upgrades itself.
            </h2>
            <p className="text-base leading-relaxed text-muted-foreground mb-10 max-w-md">{showcase.description}</p>
            <ul className="space-y-4">
              {showcase.features.map((f, i) => (
                <li key={i} className="flex items-center gap-3 text-sm border-b border-border/40 pb-4">
                  <Check className="w-4 h-4 text-accent shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.15} className="lg:sticky lg:top-24">
            <CheckoutPanel tiers={showcase.tiers} />
          </Reveal>
        </section>

        <Manifesto />
      </main>

      <footer className="border-t border-border/60">
        <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} DockBox — aftermarket checkout for indie apps.</p>
          <p className="font-mono text-xs">Payments secured by Stripe · Status stored, nothing else.</p>
        </div>
      </footer>
    </div>
  );
}
